import React from 'react';
import { Route, Routes } from 'react-router-dom';

import BookAppointment from '@pg/Appointment/BookAppointment.v2';
import ViewBookingAppointment from '@pg/Appointment/ViewBookingAppointment';
import Dashboard from '@pg/Dashboard/Dashboard';
import Error401Page from '@pg/Error/Error401Page';
import Error404Page from '@pg/Error/Error404Page';
import AgreementTerm from '@pg/FooterLink/AgreementTerm';
import HomePage from '@pg/Landing/HomePage';
import ForgotPassword from '@pg/Login/ForgotPassword';
import Login from '@pg/Login/Login';
import VerificationPage from '@pg/Login/MsgPage/VerificationPage';
import EmailVerificationPage from '@pg/Login/MsgPage/EmailVerificationPage';
import ResetPassword from '@pg/Login/ResetPassword';
import Signup from '@pg/Login/Signup';
import TokenExpired from '@pg/Login/TokenExpired';
import ChangePassword from '@pg/Profile/ChangePassword';
import Profile from '@pg/Profile/Profile';
import RewardsCatalog from '@pg/Rewards/RewardsCatalog';
import ViewServiceCase from '@pg/ServiceCase/ViewServiceCase';
import ViewServiceCaseDetails from '@pg/ServiceCase/ViewServiceCaseDetails';
import RegisterProduct from '@pg/Warranty/RegisterProduct.v2';
import ViewProductWarranty from '@pg/Warranty/ViewProductWarranty.v2';

import PageLayout from '@/layout/PageLayout.v2';
import RootLayout from '@/layout/RootLayout.v2';
import PrivateRoute from './PrivateRoute';

const Router: React.FC = () => (
    <div>
        <main>
            <Routes>
                <Route element={<RootLayout />}>
                    <Route path="/" element={<Login />} />
                    <Route path="login" element={<Login />} />
                    <Route path="registration" element={<Signup />} />
                    <Route path="forgot-password" element={<ForgotPassword />} />
                    <Route path="reset-password" element={<ResetPassword />} />
                    <Route path="token-expired" element={<TokenExpired />} />
                    <Route path="verification" element={<VerificationPage />} />
                    <Route path="footer-primary-links/privacy-policy" element={<AgreementTerm />} />
                    <Route path="footer-primary-links/warranty-terms" element={<AgreementTerm />} />
                </Route>
                <Route path="verify-email" element={<EmailVerificationPage />} />

                <Route element={<PageLayout />}>
                    <Route path="/member" element={<PrivateRoute />}>
                        <Route path="home" element={<HomePage />} />
                        <Route path="dashboard" element={<Dashboard />} />
                        <Route path="profile" element={<Profile />} />
                        <Route path="change-password" element={<ChangePassword />} />
                        <Route path="register-product" element={<RegisterProduct />} />
                        <Route path="view-warranty" element={<ViewProductWarranty />} />
                        <Route path="book-appointment" element={<BookAppointment />} />
                        <Route path="view-booking-appointment" element={<ViewBookingAppointment />} />
                        <Route path="view-service-case" element={<ViewServiceCase />} />
                        <Route path="view-service-case/:case_no" element={<ViewServiceCaseDetails />} />
                        <Route path="rewards" element={<RewardsCatalog />} />
                        <Route path="401" element={<Error401Page />} />
                        <Route path="*" element={<Error404Page />} />
                    </Route>
                </Route>

                <Route path="*" element={<Error404Page />} />
            </Routes>
        </main>
    </div>
);

export default Router;
